import Service from '../service';

export default class EmailService extends Service {
  baseApi = '/user/notifications';

  async sendEmailsToAll(body) {
    const url = `${this.baseApi}/all`;
    return await this.postResource(url, body);
  }
}
